module.exports = __webpack_public_path__ + "media/assets/img/flags/it-IT-df891e228f93d4bf850386971dbe38f8.png";